import * as React from "react";
const SvgFiRrPeanuts = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-peanuts_svg__a)">
      <path
        fill="#062147"
        d="M3.089 19.583a7.5 7.5 0 0 0 1.229 3.157c-2.493-.79-4.319-3.288-4.319-6.24 0-1.023.214-2.002.635-2.91a4.9 4.9 0 0 0 0-4.181A6.9 6.9 0 0 1-.001 6.5C0 2.916 2.691 0 6 0c3.143 0 5.729 2.632 5.98 5.968a8.6 8.6 0 0 0-1.628 2.736 2.68 2.68 0 0 1-1.335 1.512 7 7 0 0 1 .534-1.648A4.9 4.9 0 0 0 10 6.5C10 4.019 8.206 2 6 2S2 4.019 2 6.5c0 .73.151 1.426.449 2.067a6.87 6.87 0 0 1 0 5.864A4.9 4.9 0 0 0 2 16.499c0 1.192.414 2.278 1.089 3.084m18.955-4.376a6.66 6.66 0 0 1-2.436 1.563 4.7 4.7 0 0 0-2.839 2.838 6.7 6.7 0 0 1-1.562 2.436c-1.296 1.296-2.978 1.952-4.61 1.952-1.472 0-2.904-.532-3.982-1.61-2.275-2.274-2.122-6.13.342-8.593a6.66 6.66 0 0 1 2.436-1.563 4.7 4.7 0 0 0 2.838-2.838 6.7 6.7 0 0 1 1.563-2.436c1.181-1.18 2.715-1.873 4.32-1.949 1.632-.072 3.158.493 4.272 1.608 2.274 2.274 2.121 6.129-.342 8.592m-1.072-7.178C20.305 7.362 19.4 7 18.406 7q-.098 0-.197.005c-1.106.053-2.173.538-3.001 1.366a4.7 4.7 0 0 0-1.099 1.708 6.67 6.67 0 0 1-4.028 4.028 4.7 4.7 0 0 0-1.71 1.1c-1.684 1.684-1.837 4.27-.342 5.765 1.497 1.496 4.082 1.34 5.765-.342a4.7 4.7 0 0 0 1.099-1.709 6.67 6.67 0 0 1 4.028-4.028 4.7 4.7 0 0 0 1.709-1.1c1.683-1.684 1.837-4.27.342-5.764M14.5 13a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 14.5 13m-3 4a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 11.5 17"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-peanuts_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPeanuts;
